import React from 'react';
import Button from '@/common/Button';
import Modal from '@/common/Modal';

import useModal from '@/hooks/useModal';
import { logout } from '@/utils/promises';

import './styles.scss';

const SessionSignedOutModal = (): JSX.Element => {
  const [state, setState] = useModal('sessionSignedOut');
  const { show = false } = (state || {}) as any;

  const handleAcknowledge = async (): Promise<void> => {
    try {
      await logout(true, '');
    } catch (err) {
      console.error('Error during logout flow', err);
    } finally {
      setState(undefined);
    }
  };

  const Footer = (): JSX.Element => (
    <div className="d-flex justify-content-end py-1">
      <Button variant="primary" onClick={handleAcknowledge}>
        Understood
      </Button>
    </div>
  );

  return (
    <Modal
      title="Signed Out"
      show={show}
      footer={Footer}
      centered
      size="sm"
      backdrop="static"
      keyboard={false}
      className="SessionSignedOutModal"
      showClose={false}
    >
      <div className="d-flex flex-column text-left">You’ve been signed out due to inactivity. Please sign in again.</div>
    </Modal>
  );
};

export default SessionSignedOutModal;
